"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueTypeTodaVarsValue = valueTypeTodaVarsValue;
function valueTypeTodaVarsValue(value) {
  var _value$value, _value$value2;
  switch (value === null || value === void 0 ? void 0 : value.type) {
    case "value":
    case "dumbapp-result":
      return value.value;
    case "contract":
      return (_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value.address;
    case "nft":
      return (_value$value2 = value.value) === null || _value$value2 === void 0 ? void 0 : _value$value2.tokenId;
    case "wallet":
      return value.value.address;
    default:
      return null;
  }
}
//# sourceMappingURL=ValueType.js.map